import { useState } from 'react';
import { createSubscription } from '@genfun/core/api/auth';
import { openTabWithUrl } from '@genfun/core/utils/openTabWithUrl';
import { useSession } from '../utils/session';
import { Modal } from '../components/Modal';
import { PlanPicker } from './PlanPicker';
import './PricingPopup.css';

export function PricingPopup({ isOpen, onClose }) {
    const { token, user } = useSession();
    const [busy, setBusy] = useState(false);

    const handleBuy = (tier) => {
        if (!token || busy) return;
        setBusy(true);
        openTabWithUrl(() => createSubscription(token, tier).then((r) => r.url))
            .catch(() => {})
            .finally(() => setBusy(false));
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} label="Pick a plan" mobile="card" className="pricingModal">
            <div className="pricingHead">
                <h2 className="modalTitle">Unlock unlimited fantasy</h2>
                {user && <span className="pricingBalance"><span className="dot" /> <b>{user.credits ?? 0}</b> credits</span>}
            </div>
            <PlanPicker busy={busy} onBuy={handleBuy} />
        </Modal>
    );
}
